import getBlockedDatesByRange from "../components/DayDragCalendar/blockedDatesQuery.graphql";

export const fetchBlockedDatesByRange = async (
  client,
  { listId, startDate, endDate }
) => {
  try {
    const { data } = await client.query({
      query: getBlockedDatesByRange,
      variables: {
        listId,
        startDate: startDate.toISOString().split("T")[0],
        endDate: endDate.toISOString().split("T")[0],
      },
      fetchPolicy: "network-only",
    });

    return data?.getBlockedDatesByRange || [];
  } catch (error) {
    console.error("Error fetching blocked dates:", error);
    return [];
  }
};
